import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34ef14f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header header-surface-blue" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "card-label fw-bolder fs-3 mb-1 text-primary px-3 py-1 rounded" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted fs-6 me-4"
}
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = {
  class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_8 = { class: "dropdown-menu" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = {
  key: 0,
  class: "shimmer h-120 mb-2 rounded-3"
}
const _hoisted_12 = {
  key: 1,
  class: "stats-sections"
}
const _hoisted_13 = { class: "row-top" }
const _hoisted_14 = { class: "icon aqua" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "brand" }, "Rent"),
  /*#__PURE__*/_createTextVNode(" - "),
  /*#__PURE__*/_createElementVNode("b", null, "Investment")
], -1))
const _hoisted_17 = { class: "row-bottom" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = {
  key: 1,
  class: "stat"
}
const _hoisted_20 = { class: "row-top" }
const _hoisted_21 = { class: "icon aqua" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "brand" }, "Rent"),
  /*#__PURE__*/_createTextVNode(" - "),
  /*#__PURE__*/_createElementVNode("b", null, "Residential")
], -1))
const _hoisted_24 = { class: "row-bottom" }
const _hoisted_25 = { class: "value" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-divider-full" }, null, -1))
const _hoisted_27 = { class: "row-top" }
const _hoisted_28 = { class: "icon aqua" }
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Build")
], -1))
const _hoisted_31 = { class: "row-bottom" }
const _hoisted_32 = { class: "value" }
const _hoisted_33 = {
  key: 1,
  class: "stat"
}
const _hoisted_34 = { class: "row-top" }
const _hoisted_35 = { class: "icon aqua" }
const _hoisted_36 = ["src"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Fund")
], -1))
const _hoisted_38 = { class: "row-bottom" }
const _hoisted_39 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDatePicker = _resolveComponent("CustomDatePicker")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['card', _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.translate('hisbaStats')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.selectedPeriod === 'custom')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(`${_ctx.customDateFrom} till ${_ctx.customDateTo}`), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.selectedPeriod), 1),
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectPeriod('yesterday')), ["prevent"]))
              }, _toDisplayString(_ctx.translate('yesterday')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'last-7-days' }]),
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-7-days')), ["prevent"]))
              }, _toDisplayString(_ctx.translate('last7Days')), 3)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'last-30-days' }]),
                href: "#",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-30-days')), ["prevent"]))
              }, _toDisplayString(_ctx.translate('last30Days')), 3)
            ]),
            _hoisted_9,
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'custom' }]),
                href: "#",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showCustomDatePicker()), ["prevent"]))
              }, _toDisplayString(_ctx.translate('customRange')), 3)
            ])
          ])
        ]),
        _createVNode(_component_CustomDatePicker, {
          show: _ctx.showDatePicker,
          dateFrom: _ctx.customDateFrom,
          "onUpdate:dateFrom": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customDateFrom) = $event)),
          dateTo: _ctx.customDateTo,
          "onUpdate:dateTo": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customDateTo) = $event)),
          onApply: _ctx.applyCustomDates,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDatePicker = false))
        }, null, 8, ["show", "dateFrom", "dateTo", "onApply"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.investmentData)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["stat", { 'with-vdivider': _ctx.residentialData }])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("img", {
                        src: _ctx.icon('investment'),
                        alt: "Investment",
                        width: "20",
                        height: "20"
                      }, null, 8, _hoisted_15)
                    ]),
                    _hoisted_16
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatCount(_ctx.investmentData.count)), 1),
                    (_ctx.investmentData.countPercentage > 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["trend", _ctx.trendClass(_ctx.investmentData.countChange)])
                        }, [
                          _createElementVNode("template", null, [
                            _createTextVNode(_toDisplayString(Math.abs(_ctx.investmentData.countPercentage)) + "% " + _toDisplayString(_ctx.trendSymbol(_ctx.investmentData.countChange)), 1)
                          ])
                        ], 2))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.residentialData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("img", {
                        src: _ctx.icon('residential'),
                        alt: "Residential",
                        width: "20",
                        height: "20"
                      }, null, 8, _hoisted_22)
                    ]),
                    _hoisted_23
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.formatCount(_ctx.residentialData.count)), 1),
                    (_ctx.residentialData.countPercentage > 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["trend", _ctx.trendClass(_ctx.residentialData.countChange)])
                        }, [
                          (_ctx.residentialData.countPercentage > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(Math.abs(_ctx.residentialData.countPercentage)) + "% " + _toDisplayString(_ctx.trendSymbol(_ctx.residentialData.countChange)), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.buildData || _ctx.fundData)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_26,
                  (_ctx.buildData)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["stat", { 'with-vdivider': _ctx.fundData }])
                      }, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("img", {
                              src: _ctx.icon('build'),
                              alt: "Build",
                              width: "20",
                              height: "20"
                            }, null, 8, _hoisted_29)
                          ]),
                          _hoisted_30
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.formatCount(_ctx.buildData.count)), 1),
                          (_ctx.buildData.countPercentage > 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["trend", _ctx.trendClass(_ctx.buildData.countChange)])
                              }, [
                                (_ctx.buildData.countPercentage > 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(Math.abs(_ctx.buildData.countPercentage)) + "% " + _toDisplayString(_ctx.trendSymbol(_ctx.buildData.countChange)), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 2))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.fundData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("img", {
                              src: _ctx.icon('fund'),
                              alt: "Fund",
                              width: "20",
                              height: "20"
                            }, null, 8, _hoisted_36)
                          ]),
                          _hoisted_37
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.formatCount(_ctx.fundData.count)), 1),
                          (_ctx.fundData.countPercentage > 0)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["trend", _ctx.trendClass(_ctx.fundData.countChange)])
                              }, [
                                (_ctx.fundData.countPercentage > 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(Math.abs(_ctx.fundData.countPercentage)) + "% " + _toDisplayString(_ctx.trendSymbol(_ctx.fundData.countChange)), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 2))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]))
    ])
  ], 2))
}